import {
  SET_IS_COLLECT,
  SET_IS_COLLECT_SERVICE,
  COUNT
} from './mutation-types'

const mutations = {
  [SET_IS_COLLECT_SERVICE] (state, val) {
    state.alredyCollect = val
  },
  [SET_IS_COLLECT] (state, val) {
    state.alredyCollect = val
  },
  [COUNT] (state, val) {
    state.count = val
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js